import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

import 'particles.js/particles';

declare let particlesJS: any;
@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.css']
})
export class PasswordResetComponent implements OnInit {
  
  username:any;
  error:any = false;
  loading: boolean = false;

  constructor(private router: Router, private http: HttpClient) { }

  ngOnInit(): void {
    particlesJS.load('particles-js', '../../../assets/particles.json', function() {
      console.log('callback - particles-js config loaded');
    });
  }

  reset(){
    if(this.username != null){
      this.loading = true;
      let body = {
        email: this.username    
      };
      let headers = {'Authorization': 'Bearer ' + localStorage.getItem("accessToken")};
      this.http.post<any>('https://admin.iot-tracking.com/api/v2/auth/reset', body, {headers}).subscribe((data) => {
        this.loading = false;
        if(Object.keys(data).length !== 0){
          this.router.navigate(['login']);
        }else{
          this.error = true;
        }
      }, (error) => {
        this.loading = false;
        this.error = true;
      });
    }
  }

}
